import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Player } from '../classes/index';


@Injectable()
export class PlayerService {

	constructor(
		private firestore: Firestore
	) { }

	findPlayer(email){
		return getDocs(query(collectionGroup(this.firestore, 'players'), where('email', '==', email)))
		.then(collection => {
			return collection.docs.map(doc => {
				let player = new Player();
				player.fromJSON(doc.data());
				player.id = doc.id;
				let teamRef = doc.ref.parent.parent;
				//console.log('Team id:'+teamRef.id);
				let gameRef = teamRef.parent.parent;
				//console.log('Game id:'+gameRef.id);
				player.gameId = gameRef.id;
				return player;
			});
		})
	}

	listHighRatingPlayers(gameId, playerLimit){
		return collectionData(query(collectionGroup(this.firestore, 'players'), where("gameId", "==", gameId), where("rating", "==", 5), 
			where("websiteComment", "!=", ""), limit(playerLimit)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let player = new Player();
				player.fromJSON(data);
				return player;
			});
		}));
	}

	get5Ratings(){
		return getDocs(query(collectionGroup(this.firestore, 'players'), where("rating", "==", 5)))
		.then(collection => {
			return collection.docs.map(doc => {
				let player = new Player();
				player.fromJSON(doc.data());
				player.id = doc.id;
				return player;
			});
		})
	}

	getPlayer(gameId, teamId, playerUid){
        return docData(doc(this.firestore, `games/${gameId}/teams/${teamId}/players/${playerUid}`), { idField: 'id' });
	}

	addPlayer(gameId, teamId, player) {
		return addDoc(collection(this.firestore, `games/${gameId}/teams/${teamId}/players`), {...player});
	}

	setPlayer(gameId, teamId, playerUid, player) {
		return setDoc(doc(this.firestore, `games/${gameId}/teams/${teamId}/players/${playerUid}`), player);
	}

	updatePlayer(gameId, teamId, playerUid, data){
		return updateDoc(doc(this.firestore, `games/${gameId}/teams/${teamId}/players/${playerUid}`), data);
	}

	deletePlayer(gameId, teamId, playerUid) {
		return deleteDoc(doc(this.firestore, `games/${gameId}/teams/${teamId}/players/${playerUid}`));
	}
}
